<div class="row">
  <div class="col-md-6">
    <div style="text-align:center">
      <apx-chart
        [series]="engineChart!.series!"
        [title]="engineChart!.title!"
        [labels]="engineChart!.labels!"
        [chart]="commonOptions!.chart!"
        [colors]="commonOptions!.colors!"
        [fill]="commonOptions!.fill!"
        [dataLabels]="commonOptions!.dataLabels!"
        [markers]="commonOptions!.markers!"
        [stroke]="commonOptions!.stroke!"
        [grid]="commonOptions!.grid!"
        [tooltip]="commonOptions!.tooltip!"
        [xaxis]="commonOptions!.xaxis!"
        [yaxis]="commonOptions!.yaxis!"
        [legend]="commonOptions!.legend!"
      ></apx-chart>
    </div>
  </div>
  <div class="col-md-6">
    <div style="text-align:center">
      <apx-chart
        [series]="decisionChart!.series!"
        [title]="decisionChart!.title!"
        [labels]="decisionChart!.labels!"
        [chart]="commonOptions!.chart!"
        [colors]="commonOptions!.colors!"
        [fill]="commonOptions!.fill!"
        [dataLabels]="commonOptions!.dataLabels!"
        [markers]="commonOptions!.markers!"
        [stroke]="commonOptions!.stroke!"
        [grid]="commonOptions!.grid!"
        [tooltip]="commonOptions!.tooltip!"
        [xaxis]="commonOptions!.xaxis!"
        [yaxis]="commonOptions!.yaxis!"
        [legend]="commonOptions!.legend!"
      ></apx-chart>
    </div>
  </div>
</div>
